import { VenueOption } from "./useVenueOptions";

type VenuePickerProps = {
  /** Venuet sensorn sitter på nu, eller null när den är oansluten. */
  current: VenueOption | null;
  value: string;
  options: VenueOption[];
  disabled?: boolean;
  label?: string;
  onChange: (venueId: string) => void;
};

/**
 * Rullgardinen som pekar ut ett venue.
 *
 * Det nuvarande venuet läggs alltid till i listan. Utan det försvinner
 * sensorns egen venue ur valet så fort någon skrivit en sökning som
 * inte råkar matcha den, och rullgardinen ser ut att ha tappat bort var
 * sensorn sitter.
 */
export default function VenuePicker({
  current,
  value,
  options,
  disabled,
  label = "Venue",
  onChange,
}: VenuePickerProps) {
  const merged =
    current && !options.some((option) => option.id === current.id)
      ? [current, ...options]
      : options;

  return (
    <label className="sensor-venue-field">
      {label}
      <select
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      >
        <option value="">Select venue…</option>
        {merged.map((venue) => (
          <option key={venue.id} value={venue.id}>
            {venue.name}
          </option>
        ))}
      </select>
    </label>
  );
}
